'use client';
import { ReactNode } from 'react';
import { ApplicationInsights, DistributedTracingModes, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking, AppInsightsContext } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
	config: {
		connectionString: process.env.NEXT_PUBLIC_AZURE_APP_INSIGHTS_KEY,
		disableAjaxTracking: false,
		disableCookiesUsage: true,
		disableDbgExt: true,
		disableExceptionTracking: false,
		disableFetchTracking: false,
		disableTelemetry: false,
		loggingLevelTelemetry: 0,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		extensions: [reactPlugin as any],
		disablePageUnloadEvents: ['unload'],
		enableAutoRouteTracking: true,
		enableCorsCorrelation: true,
		enableRequestHeaderTracking: true,
		disableCorrelationHeaders: false,
		enableResponseHeaderTracking: true,
		distributedTracingMode: DistributedTracingModes.AI_AND_W3C,
		correlationHeaderExcludedDomains: ['*.zdassets.com'],
	},
});

if (process.env.NODE_ENV === 'production') {
	appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
		envelope.tags = envelope.tags || [];
		envelope.tags.push({ 'ai.cloud.role': process.env.NEXT_PUBLIC_AZURE_APP_INSIGHTS_CLOUD_ROLE });
	});
	appInsights.loadAppInsights();
	appInsights.trackPageView();
}

const AzureAppInsights = ({ children }: { children: ReactNode }) => {
	return <AppInsightsContext.Provider value={reactPlugin}>{children}</AppInsightsContext.Provider>;
};

export default withAITracking(reactPlugin, AzureAppInsights);
